import { Add } from '@mui/icons-material';
import CheckIcon from "@mui/icons-material/Check";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpIcon from '@mui/icons-material/Help';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, BottomNavigation, BottomNavigationAction, Box, Radio, TextField } from '@mui/material';
import Checkbox from "@mui/material/Checkbox";
import axios from 'axios';
import { limitToLast, onChildAdded, onChildChanged, query, ref } from 'firebase/database';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import defaultImage from "../../assets/svg/defultImage.svg";
import noData from "../../assets/svg/Emptyfile1.svg";
import recommendation from "../../assets/svg/filter-recommendation.svg";
import { database } from '../../firebase';
import { newHost } from '../../pages/Categories/CategoryProfile';
import { newImageUrl } from '../../pages/Manufacturers/ManufactureProfile';
import DeleteModal from '../Modals/DeleteModal';



const ActivityItem = ({
  activity,
  requestId,
  token,
  newHost,
  callTypes,
  callStatuses,
  activityTypes,
  getRequest,
  request,
  handleDeleteClose,
  handleDeleteShow,
  setActivityId,
  activityId
}) => {

  const [isEdit, setIsEdit] = useState(false)

  const {
    register,
    handleSubmit,
    control,
    reset
  } = useForm({
    defaultValues: {
      activity_type_id: activity.activity_type_id,
      call_type_id: activity.call_type_id,
      call_status_id: activity.call_status_id,
      comment: activity.comment,
      description: activity.description,
    }
  })

  const handleEdit = (id) => {
    setIsEdit(true)
    setActivityId(id)
    reset({
      activity_type_id: activity.activity_type_id,
      call_type_id: activity.call_type_id,
      call_status_id: activity.call_status_id,
      comment: activity.comment,
      description: activity.description,
    })
  }

  const onSubmit = async (data) => {
    try {

      const response = await axios.post(
        `${newHost}portal/estbn_helps/${requestId}/activity_logs/${activityId}`,
        {
          ...data,
          _method: "PUT"
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )

      setIsEdit(false)
      toast.success(response.data.message)
      getRequest()

    } catch (error) {
      const validationErrors = error.response?.data.errors?.validation;

      Object.entries(validationErrors).forEach(([field, messages]) => {
        messages.forEach((msg) => {
          toast.error(msg);
        });
      });
    }
  }
  useEffect(() => {
    reset({
      activity_type_id: activity.activity_type_id,
      call_type_id: activity.call_type_id,
      call_status_id: activity.call_status_id,
      comment: activity.comment,
      description: activity.description,
    })
  }, [])



  return (
    <>

      <div
        className="activity-log-item d-flex flex-column flex-md-row mt-3 mx-1"
      >
        <div className=" col-md-3 pt-2 fw-semibold text-center mb-3 mb-md-0 ">
          <div>
            <p className="my-2">{`${new Date(activity.created_at).toLocaleDateString()} - ${new Date(activity.created_at).toLocaleTimeString()}`}</p>
            <p>{request?.agentable?.name}</p>
          </div>
        </div>
        <div className="col-md-9 px-3 mx-2 border-start border-2 activity-log">
          <i className="fa-solid fa-circle activity-log-icon fa-xs"></i>
          <form className='mx-2' >
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="w-100 ">
                  <label htmlFor="call_type_id">Call Type</label>
                  <Controller
                    name="call_type_id"
                    control={control}
                    render={({ field }) => {

                      const options = callTypes.map(option => ({
                        label: option.name,
                        id: option.id,
                      }));

                      return (
                        <Autocomplete
                          className='w-100'
                          size="small"
                          options={options}
                          // disabled={!isEdit}
                          readOnly={!isEdit}
                          value={options.find(opt => opt.id == field.value) || null}
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}
                          getOptionLabel={(option) => option.label || ""}
                          isOptionEqualToValue={(option, value) => option.id == value.id}
                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Title"
                            />
                          )}
                        />
                      );
                    }}
                  />

                </div>
              </div>
              <div className="col-md-4 col-12">
                <div className="w-100">
                  <label htmlFor="call_status_id">Call Status</label>
                  <Controller
                    name="call_status_id"
                    control={control}
                    render={({ field }) => {
                      const options = callStatuses.map(option => ({
                        label: option.name,
                        id: option.id,
                      }));

                      return (
                        <Autocomplete
                          className='w-100'
                          size="small"
                          // disabled={!isEdit}
                          readOnly={!isEdit}
                          options={options}
                          value={options.find(opt => opt.id == field.value) || null}
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}
                          getOptionLabel={(option) => option.label || ""}
                          isOptionEqualToValue={(option, value) => option.id == value.id}
                          id='call_status_id'

                          getOptionLabel={(option) => option.label || ""}
                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="m-0"
                              placeholder="Select Title"
                            />
                          )}
                        />
                      );
                    }}
                  />
                </div>
              </div>
              <div className="col-md-4 col-12">
                <div className="w-100 ">
                  <label htmlFor="activity_type_id">Activity Type</label>
                  <Controller
                    name="activity_type_id"
                    control={control}
                    render={({ field }) => {
                      const options = activityTypes.map(option => ({
                        label: option.effect_value,
                        id: option.id,
                        icon_url: option.icon_url
                      }));

                      return (
                        <Autocomplete
                          className='w-100'
                          size="small"
                          options={options}
                          // disabled={!isEdit}
                          readOnly={!isEdit}
                          value={options.find(opt => opt.id == field.value) || null}
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}
                          getOptionLabel={(option) => option.label || ""}
                          isOptionEqualToValue={(option, value) => option.id == value.id}
                          getOptionLabel={(option) => option.label || ""}
                          id='activity_type_id'

                          renderOption={(props, option) => (
                            <div {...props} className="p-2 d-flex align-items-center gap-2">
                              <div style={{ width: "20px", height: "20px" }} className="">
                                <img style={{ width: "100%", objectFit: "fill" }} className='' src={option.icon_url ? option.icon_url : defaultImage} alt="" />
                              </div>

                              <div className="m-0">{option.label}</div>
                            </div>
                          )}

                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="m-0"
                              placeholder="Select Title"
                            />
                          )}
                        />
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="my-2">
              <label htmlFor="comment">Client Comments</label>
              <textarea {...register("comment")} readOnly={!isEdit} defaultValue={activity?.comment} id='comment' style={{ padding: 10, borderRadius: 5, border: "solid 2px #D8D8D8", }} rows={3} className='w-100 my-1' type='text' placeholder='Add Comments'

              />
            </div>
            <div className="my-2">
              <label htmlFor="description">Agent Notes</label>
              <textarea {...register("description")} readOnly={!isEdit} defaultValue={activity?.description} id='description' style={{ padding: 10, borderRadius: 5, border: "solid 2px #D8D8D8", }} rows={3} className='w-100 my-1' type='text' placeholder='Add notes'

              />
            </div>
            <div className="d-flex justify-content-end align-items-center gap-2 my-1">
              <button type='button' onClick={() => handleDeleteShow(activity.id)} style={{ border: "solid #A80101", color: "#A80101" }} className="btn px-3">Delete</button>
              <button
                type="button"
                onClick={() => {
                  if (isEdit) {
                    handleSubmit(onSubmit)()
                  } else {
                    handleEdit(activity.id)
                  }
                }}
                className="btn btn-dark px-4"
              >
                {isEdit ? "Save" : "Edit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

const HelpRequestProfile = () => {
  const { user } = useSelector((state) => state.auth);
  const token = user?.token;
  const { id: requestId } = useParams()
  const [tabValue, setTabValue] = useState(0)
  const [expandedOrder, setExpandedOrder] = useState(null);

  // request details & activity logses
  const [request, setRequest] = useState({})
  const [activities, setActivities] = useState([])
  const [filterItemsData, setFilterItemsData] = useState([])


  const getRequest = async () => {
    try {
      const response = await axios.get(`${newHost}portal/estbn_helps/${requestId}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      setRequest(response.data.data.estbn_help)
      setActivities(response.data.data?.activity_logs)
      setProducts(response.data.data?.category_products)
      setFilterItemsData(response.data.data?.estbn_help.items)

    } catch (error) {
      console.log(error);

    }

  }
  useEffect(() => {
    getRequest()
  }, [])



  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    getValues
  } = useForm({
    defaultValues: {
      activity_type_id: null,
      call_type_id: null,
      call_status_id: null,
      description: null,
      comment: null

    }
  });
  const [activityShow, setActivityShow] = useState(false)

  const handleActivityShow = () => {
    setActivityShow(true)

  }
  const handleActivityClose = () => {
    setActivityShow(false)
    reset({
      activity_type_id: null,
      call_type_id: null,
      call_status_id: null,
      description: null,
      comment: null
    })
  }
  const [callTypes, setCallTypes] = useState([])
  const [callStatuses, setCallStatues] = useState([])
  const [activityTypes, setActivityTypes] = useState([])

  const getCallTypes = async () => {
    try {
      const response = await axios.get(`${newHost}portal/call_types`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }

      )

      setCallTypes(response.data.data.call_types);

    } catch (error) {
      console.log(error);

    }
  }
  const getCallStatues = async () => {
    try {
      const response = await axios.get(`${newHost}portal/call_statuses`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }

      )

      setCallStatues(response.data.data.call_statuses);

    } catch (error) {
      console.log(error);

    }
  }
  const getActivityTypes = async () => {
    try {
      const response = await axios.get(`${newHost}portal/estbn_helps/activity_types/get`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }

      )

      setActivityTypes(response.data.data.types);

    } catch (error) {
      console.log(error);

    }
  }

  useEffect(() => {
    getCallTypes()
    getCallStatues()
    getActivityTypes()
  }, [])
  const submitActivity = async (data) => {


    try {
      const response = await axios.post(`${newHost}portal/estbn_helps/${requestId}`, {
        ...data,
        _method: "PUT"
      },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      toast.success(response.data.message)
      handleActivityClose()
      getRequest()
    } catch (error) {


      const validationErrors = error.response?.data.errors?.validation;

      Object.entries(validationErrors).forEach(([field, messages]) => {
        messages.forEach((msg) => {
          toast.error(msg);
        });
      });

    }
  }

  const [showDelete, setShowDelete] = useState(false)
  const [activityId, setActivityId] = useState(null)

  const handleDeleteShow = (id) => {
    setActivityId(id)
    setShowDelete(true)
  }
  const handleDeleteClose = () => {
    setShowDelete(false)
  }

  const deleteActivity = async () => {
    try {
      const response = await axios.delete(`${newHost}portal/estbn_helps/${requestId}/activity_logs/delete?activity_log_id=${activityId}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      toast.success(response.data.message)
      handleDeleteClose()
      getRequest()
    } catch (error) {
      toast.error(error.response.data.message)

    }
  }

  // recommentations
  const [recommendationShow, setRecommendationShow] = useState(false)




  const handleRecommendationShow = () => {
    setRecommendationShow(true)
  }
  const handleRecommendationClose = () => {
    setRecommendationShow(false)
    setSelectedMultipleProducts([])
    setSelectedProduct(null)
    setOptionType("single")
  }
  //
  const [optionType, setOptionType] = useState("single")
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const handleProductChange = (item) => {

    if (!item) {
      setSelectedProduct(null);
      return;
    }

    setSelectedProduct({
      id: item.id,
      name: item.name,
      image: item.profile_image_url,
      quantity: 1,
      price: item.current_price,
      type: item.product_details?.brand_name
    });
  };
  const increaseQty = () => {
    setSelectedProduct((prev) => ({
      ...prev,
      quantity: prev.quantity + 1,
    }));
  };

  const decreaseQty = () => {
    setSelectedProduct((prev) => ({
      ...prev,
      quantity: prev.quantity > 1
        ? prev.quantity - 1
        : 1,
    }));
  };
  const removeProduct = () => {
    setSelectedProduct(null);
  };
  const submitProduct = async () => {

    const formData = new FormData();
    formData.append(
      "items[0][product_id]",
      selectedProduct.id
    );

    formData.append(
      "items[0][quantity]",
      selectedProduct.quantity
    );
    try {

      const response = await axios.post(
        `${newHost}portal/estbn_helps/${requestId}/add-items-to-help-request`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      toast.success(response.data.message);
       handleRecommendationClose()
      //  getRequest()
    } catch (error) {

      toast.error(error.response.data.message);

    }
  };


  const [selectedMultipleProducts, setSelectedMultipleProducts] = useState([]);

  const handleMultipleProductChange = (items) => {

    setSelectedMultipleProducts((prev) => {

      return items.map((item) => {

        const existingProduct = prev.find(
          (product) => product.id === item.id
        );

        if (existingProduct) {
          return existingProduct;
        }

        return {
          id: item.id,
          name: item.name,
          image: item.profile_image_url,
          quantity: 1,
          price: item.current_price,
          type: item.product_details?.brand_name,
        };
      });

    });

  };
  const increaseMultipleQty = (id) => {

    setSelectedMultipleProducts((prev) =>
      prev.map((product) =>
        product.id === id
          ? {
            ...product,
            quantity: product.quantity + 1,
          }
          : product
      )
    );
  };
  const decreaseMultipleQty = (id) => {

    setSelectedMultipleProducts((prev) =>
      prev.map((product) =>
        product.id === id
          ? {
            ...product,
            quantity:
              product.quantity > 1
                ? product.quantity - 1
                : 1,
          }
          : product
      )
    );
  };
  const removeMultipleProduct = (id) => {

    setSelectedMultipleProducts((prev) =>
      prev.filter((product) => product.id !== id)
    );
  };
  const submitMultipleProducts = async () => {

    const formData = new FormData();

    selectedMultipleProducts.forEach((product, index) => {

      formData.append(
        `items[${index}][product_id]`,
        product.id
      );

      formData.append(
        `items[${index}][quantity]`,
        product.quantity
      );

    });

    try {

      const response = await axios.post(
        `${newHost}portal/estbn_helps/${requestId}/add-items-to-help-request`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      toast.success(response.data.message);
       handleRecommendationClose()
    } catch (error) {

      toast.error(error.response.data.message);

    }
  };
  const boxStyle = {
    width: 25,
    height: 25,
    border: "2px solid #D1D5DB",
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const isPending = request.status === "pending"
  const isSentToUser = request.status === "sent_to_user"
  const isResolved = request.status === "resolved"
  const isUnResolved = request.status === "unresolved"
  const isCancelled = request.status === "cancelled"


const selectedProductsImage = request.items?.filter((item) => item?.confirmed)
  .map((item) => (
    <div key={item?.product?.id}>
      <img
        style={{ width: "50px", height: "50px" }}
        src={
          item.product?.profile_image_url
            ? `${newImageUrl}${item.product?.profile_image_url}`
            : defaultImage
        }
        alt={item.product?.name}
      />
    </div>
  ));


// filter Data
const [filterDataShow, setfilterDataShow] = useState(false)
const handleFilterDataShow = ()=>{
  setfilterDataShow(true)
}
const handleFilterDataClose = ()=>{
  setfilterDataShow(false)
}
const confirmedItem = request?.items?.filter((item)=> item?.confirmed == true)


  // ****************** firbase ************************


const [updatedStatusIds, setUpdatedStatusIds] = useState(new Set());
const [requestStatuses, setRequestStatuses] = useState([]);
  const getRequestStatuses = async () => {
     try {
       const response = await axios.get(
         `${newHost}portal/estbn_helps/statuses/get`,
         {
           headers: { Authorization: `Bearer ${token}` },
         },
       );
 
       console.log(response.data.data.statuses);
       setRequestStatuses(response.data.data.statuses);
     } catch (error) {
       console.log(error);
     }
   };

   useEffect(() => {
    getRequestStatuses()
   }, [])
   
useEffect(() => {
  if (!token || !requestStatuses.length) return;

  const statusRef = ref(database, "status_updated/help_requests");
console.log(statusRef);

  const handleStatusUpdate = (snapshot) => {
  const helpRequestId = Number(snapshot.key);

  if (helpRequestId !== Number(requestId)) return;

  const data = snapshot.val();

  if (!data?.updated_at) return;

  const newStatus = requestStatuses.find(
    (s) => s.value === data.status
  );

  if (!newStatus) return;

  setRequest((prev) => ({
    ...prev,
    status: newStatus.value,
    status_icon: newStatus.icon,
  }));

  setUpdatedStatusIds((prev) => new Set([...prev, helpRequestId]));

  if (
    ["resolved", "sent_to_user", "unresolved"].includes(data.status)
  ) {
    getRequest();
  }

  setTimeout(() => {
    setUpdatedStatusIds((prev) => {
      const next = new Set(prev);
      next.delete(helpRequestId);
      return next;
    });
  }, 8000);
};
  const unsub1 = onChildAdded(query(statusRef, limitToLast(1)), handleStatusUpdate);
  const unsub2 = onChildChanged(statusRef, handleStatusUpdate);

  return () => {
    unsub1();
    unsub2();
  };
}, [token, requestStatuses]);
 const isUpdated = updatedStatusIds.has(request.id);

  return (
    <>
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={`Are you sure you want to delete this activity? Confirm to proceed or cancel to keep it.`}
        deleteFunction={deleteActivity}
      />
      <Modal show={activityShow} onHide={handleActivityClose} dialogClassName='custom-modal-size'>
        <Modal.Header style={{ backgroundColor: "#F8F8F8" }}>
          <Modal.Title className="text-black">Add activity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="my-2">
            <form onSubmit={handleSubmit(submitActivity)}>
              <div className="mt-2 mb-3 row">

                <div className="col-md-4 col-12">
                  <label htmlFor="call_type_id">Call Type</label>
                  <Controller
                    name="call_type_id"
                    control={control}
                    render={({ field }) => {
                      const options = callTypes.map(option => ({
                        label: option.name,
                        id: option.id,
                      }));

                      return (
                        <Autocomplete
                          className='w-100'
                          size="small"
                          options={options}
                          value={options?.find(opt => opt.id == field.value) || null}
                          id='call_type_id'
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="m-0"
                              placeholder="Select Title"
                            />
                          )}
                        />
                      );
                    }}
                  />
                </div>
                <div className="col-md-4 col-12">
                  <label htmlFor="call_status_id">Call Status</label>
                  <Controller
                    name="call_status_id"
                    control={control}
                    render={({ field }) => {
                      const options = callStatuses.map(option => ({
                        label: option.name,
                        id: option.id,
                      }));

                      return (
                        <Autocomplete
                          className='w-100'
                          size="small"
                          options={options}
                          value={options?.find(opt => opt.id == field.value) || null}
                          id='call_status_id'
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="m-0"
                              placeholder="Select Title"
                            />
                          )}
                        />
                      );
                    }}
                  />
                </div>
                <div className="col-md-4 col-12">
                  <label htmlFor="activity_type_id">Activity Type</label>
                  <Controller
                    name="activity_type_id"
                    control={control}
                    render={({ field }) => {
                      const options = activityTypes.map(option => ({
                        label: option.effect_value,
                        id: option.id,
                        icon_url: option.icon_url
                      }));

                      return (
                        <Autocomplete
                          className='w-100'
                          size="small"
                          options={options}
                          value={options?.find(opt => opt.id == field.value) || null}
                          id='activity_type_id'
                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <div {...props} className="p-2 d-flex align-items-center gap-2">
                              <div style={{ width: "20px", height: "20px" }} className="">
                                <img style={{ width: "100%", objectFit: "fill" }} className='' src={option.icon_url ? option.icon_url : defaultImage} alt="" />
                              </div>

                              <div className="m-0">{option.label}</div>
                            </div>
                          )}

                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="m-0"
                              placeholder="Select Title"
                            />
                          )}
                        />
                      );
                    }}
                  />
                </div>
              </div>
              <div className="my-3">
                <label htmlFor="comment">Client Comments</label>
                <textarea {...register("comment")} id='comment' style={{ padding: 10, borderRadius: 5, border: "solid 2px #D8D8D8", }} rows={3} className='w-100 my-1' type='text' placeholder='Add Comments'

                />
              </div>
              <div className="my-2">
                <label htmlFor="description">Agent Notes</label>
                <textarea {...register("description")} id='description' style={{ padding: 10, borderRadius: 5, border: "solid 2px #D8D8D8", }} rows={3} className='w-100 my-1' type='text' placeholder='Add notes'

                />
              </div>

              <div className="d-flex gap-3 justify-content-center align-items-center my-3 input-group-responsive">
                <button type="reset" onClick={handleActivityClose} className="btn btn-light px-5">Cancel</button>
                <button className="btn btn-dark px-5">Save</button>

              </div>

            </form>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={filterDataShow} onHide={handleFilterDataClose} dialogClassName='custom-modal-size'>
        <Modal.Header style={{ backgroundColor: "#F8F8F8" }}>
          <Modal.Title className="text-black">View Recommendations (Read Only)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <div className="my-2">
              <div style={{ border: "2px dashed #C6C6C6" }} className="p-3">
                <div className="d-flex gap-2 align-items-center">
                  <div className="">
                    <img src={recommendation} alt="" className="" />
                  </div>
                  <div className="">
                    <h6 className="m-0">{`Help Request - Oil Filter`}</h6>
                    <h6 className="m-0 main-text-color label-size">Customer asked for help to choose the right oil filter.</h6>
                  </div>

                </div>
              </div>
            </div>
            <div className="my-3 border-bottom w-100 py-3">
              <div className="d-flex gap-2 align-items-start">
                <span
                  style={{
                    width: "25px", height: "25px",
                    padding: "10px", borderRadius: "50%",
                    backgroundColor: "#3FBEAC"
                  }}
                  className="d-flex justify-content-center align-items-center fw-bold"> 1
                </span>
                <div className="">
                  <h5 className="fw-semibold">Recommendation type</h5>
                  <p className="m-0 main-text-center label-size">Choose how many options to send to the client.</p>


                  <div className="d-flex gap-2 align-items-center my-2 opacity-50">
                    <input disabled  checked={request?.items?.length == 1}  style={{ accentColor: "black" }} type="radio" name="type" id="" />
                    <p className="m-0 fw-semibold label-size">Single Option <span className='main-text-color'>(best recommendation)</span></p>
                  </div>
                  <div className="d-flex gap-2 align-items-center my-2 opacity-50">
                    <input disabled checked={request?.items?.length > 1}  style={{ accentColor: "black" }} type="radio" name="type" id="" />
                    <p className="m-0 fw-semibold label-size">Multiple Option <span className='main-text-color'>(let client choose)</span></p>
                  </div>

                </div>

              </div>
            </div>
            <div className="my-3 border-bottom w-100 py-3">
              <div className="d-flex gap-2 align-items-start">
                <span
                  style={{
                    width: "25px", height: "25px",
                    padding: "10px", borderRadius: "50%",
                    backgroundColor: "#3FBEAC"
                  }}
                  className="d-flex justify-content-center align-items-center fw-bold"> 2
                </span>
                <div className="">
                  <h5 className="fw-semibold">Add Products</h5>
                  <p className="m-0 main-text-center label-size">Add the suitable product and send to the client.</p>


                </div>

              </div>
      
                <>
                  <div className="my-3">
                  
                    {request.items?.length > 0 ?
                    isResolved?
                      confirmedItem?.map((item) => 
                          <div

                      
                          key={item.id}
                          className="my-2 border rounded-3 p-3 opacity-50"
                          
                        >

                          <div className="row">

                            <div className="col-md-6 col-12">

                              <div className="d-flex align-items-center gap-3">

                               <div className="">
                                 <img
        style={{width:"50px", height:"50px"}}
          src={
            item?.product?.profile_image_url
              ? `${newImageUrl}${item?.product?.profile_image_url}`
              : defaultImage
          } />
                               </div>

                                <div>
                                  <h6 className='fw-bold label-size'>
                                    {item?.product.name}
                                  </h6>
                     <h6 className='m-0 label-size main-text-color'>Type: {item?.product_details?.brand_name}</h6>
                                 

                         <h6 className='m-0 label-size main-text-color'>
                                    Price:
                                    <span className='fw-bold text-black'>
                                      {item?.product?.current_price * item?.quantity } EGP
                                    </span>
                                  </h6>
                                </div>

                              </div>

                            </div>

                            <div className="col-md-6 col-12">

                              <div className="d-flex justify-content-between align-items-start">

                                <div>

                                  <h6 className="m-0 main-text-color">
                                    Qty
                                  </h6>

                                  <div className="border rounded-2 d-flex align-items-center">

                                    <button
                                    disabled
                                      style={{
                                        border: "none",
                                        outline: "none"
                                      }}
                                     
                                      className='py-2 px-3 bg-transparent rounded-2 main-text-color'
                                    >
                                      -
                                    </button>

                                    <span>{item?.quantity}</span>

                                    <button
                                    disabled
                                      style={{
                                        border: "none",
                                        outline: "none"
                                      }}
                                   
                                      className='py-2 px-3 bg-transparent rounded-2 main-text-color'
                                    >
                                      +
                                    </button>

                                  </div>

                                </div>

                                <div
                                
                                >
                                    <DeleteOutlinedIcon  color='error' />
                                  
                                  
                                </div>

                              </div>

                            </div>

                          </div>

                        </div>
                        
                        )
                        : request.items?.map((item)=>
                        <div

                      
                          key={item.id}
                          className="my-2 border rounded-3 p-3 opacity-50"
                          
                        >

                          <div className="row">

                            <div className="col-md-6 col-12">

                              <div className="d-flex align-items-center gap-3">

                               <div className="">
                                 <img
        style={{width:"50px", height:"50px"}}
          src={
            item?.product?.profile_image_url
              ? `${newImageUrl}${item?.product?.profile_image_url}`
              : defaultImage
          } />
                               </div>

                                <div>
                                  <h6 className='fw-bold label-size'>
                                    {item?.product.name}
                                  </h6>

                                 <h6 className='m-0 label-size main-text-color'>Type: {item?.product?.product_details?.brand_name}</h6>

                                  <h6 className='m-0 label-size main-text-color'>
                                    Price:
                                    <span className='fw-bold text-black'>
                                      {item?.product?.current_price * item?.quantity} EGP
                                    </span>
                                  </h6>
                                </div>

                              </div>

                            </div>

                            <div className="col-md-6 col-12">

                              <div className="d-flex justify-content-between align-items-start">

                                <div>

                                  <h6 className="m-0 main-text-color">
                                    Qty
                                  </h6>

                                  <div className="border rounded-2 d-flex align-items-center">

                                    <button
                                    disabled
                                      style={{
                                        border: "none",
                                        outline: "none"
                                      }}
                                     
                                      className='py-2 px-3 bg-transparent rounded-2 main-text-color'
                                    >
                                      -
                                    </button>

                                    <span>{item?.quantity}</span>

                                    <button
                                    disabled
                                      style={{
                                        border: "none",
                                        outline: "none"
                                      }}
                                   
                                      className='py-2 px-3 bg-transparent rounded-2 main-text-color'
                                    >
                                      +
                                    </button>

                                  </div>

                                </div>

                                <div
                                  
                                
                                >
                                  <DeleteOutlinedIcon color='error' />
                                </div>

                              </div>

                            </div>

                          </div>

                        </div>
                        )
                        :
                        null
                      
                      }
                  </div>
                </>
              


            </div>
            <div className="my-5">
              <div className="d-flex gap-2 align-items-start">
                <span
                  style={{
                    width: "25px", height: "25px",
                    padding: "10px", borderRadius: "50%",
                    backgroundColor: "#3FBEAC"
                  }}
                  className="d-flex justify-content-center align-items-center fw-bold"> 3
                </span>
                <div className="">  
                  <h5 className="fw-semibold">Send to client</h5>
                  <p className="m-0 main-text-center label-size">The client will receive these options on their app.</p>


                </div>

              </div>
            </div>
           
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={recommendationShow} onHide={handleRecommendationClose} dialogClassName='custom-modal-size'>
        <Modal.Header style={{ backgroundColor: "#F8F8F8" }}>
          <Modal.Title className="text-black">Add Recommendation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <div className="my-2">
              <div style={{ border: "2px dashed #C6C6C6" }} className="p-3">
                <div className="d-flex gap-2 align-items-center">
                  <div className="">
                    <img src={recommendation} alt="" className="" />
                  </div>
                  <div className="">
                    <h6 className="m-0">{`Help Request - Oil Filter`}</h6>
                    <h6 className="m-0 main-text-color label-size">Customer asked for help to choose the right oil filter.</h6>
                  </div>

                </div>
              </div>
            </div>
            <div className="my-3 border-bottom w-100 py-3">
              <div className="d-flex gap-2 align-items-start">
                <span
                  style={{
                    width: "25px", height: "25px",
                    padding: "10px", borderRadius: "50%",
                    backgroundColor: "#3FBEAC"
                  }}
                  className="d-flex justify-content-center align-items-center fw-bold"> 1
                </span>
                <div className="">
                  <h5 className="fw-semibold">Recommendation type</h5>
                  <p className="m-0 main-text-center label-size">Choose how many options to send to the client.</p>


                  <div className="d-flex gap-2 align-items-center my-2">
                    <input checked={optionType == "single"} onChange={() => setOptionType("single")} style={{ accentColor: "black" }} type="radio" name="type" id="" />
                    <p className="m-0 fw-semibold label-size">Single Option <span className='main-text-color'>(best recommendation)</span></p>
                  </div>
                  <div className="d-flex gap-2 align-items-center my-2">
                    <input checked={optionType == "multiple"} onChange={() => setOptionType("multiple")} style={{ accentColor: "black" }} type="radio" name="type" id="" />
                    <p className="m-0 fw-semibold label-size">Multiple Option <span className='main-text-color'>(let client choose)</span></p>
                  </div>

                </div>

              </div>
            </div>
            <div className="my-3 border-bottom w-100 py-3">
              <div className="d-flex gap-2 align-items-start">
                <span
                  style={{
                    width: "25px", height: "25px",
                    padding: "10px", borderRadius: "50%",
                    backgroundColor: "#3FBEAC"
                  }}
                  className="d-flex justify-content-center align-items-center fw-bold"> 2
                </span>
                <div className="">
                  <h5 className="fw-semibold">Add Products</h5>
                  <p className="m-0 main-text-center label-size">Add the suitable product and send to the client.</p>


                </div>

              </div>
              {optionType == "single" &&
                <>
                  <div className="my-3">
                    <Autocomplete
                      className='w-100 h-100'
                      size="small"
                      options={products}
                      value={products?.find(opt => opt.id == selectedProduct?.id) || null}
                      id='products'
                      onChange={(e, item) => {

                        handleProductChange(item)
                      }
                      }
                      getOptionLabel={(option) => option.name || ""}
                      renderOption={(props, option) => (
                        <li {...props}  
                      style={{
      ...props.style,
      opacity: option?.stock_status === "out_of_stock" ? 0.5 : 1,
      pointerEvents:
        option?.stock_status === "out_of_stock" ? "none" : "auto",
    }} className='px-1' >
                          <div className="d-flex justify-content-between align-items-center p-2">
                            <div className="d-flex align-items-start gap-2">
                              <img
                                src={
                                  option.profile_image_url
                                    ? `${newImageUrl}${option.profile_image_url}`
                                    : defaultImage
                                }
                                style={{ width: 30, marginInline: 15 }}
                                alt=""
                              />
                              <div className="">
                                <h6 className='fw-bold label-size'>{option?.name}</h6>
                                <h6 className='m-0 label-size main-text-color'>Type: {option?.product_details?.brand_name}</h6>
                                <h6 className='m-0 label-size main-text-color'>Price:  <span className='fw-bold text-black'>{option?.current_price} EGP</span></h6>

                              </div>

                                                   {option?.stock_status === "out_of_stock" && (
    <span
      style={{
        color: "#A80101",
        fontSize: "11px",
        fontWeight: 600,
      }}
    >
      Out of stock
    </span>
  )}


                            </div>

                            <Radio
                              checked={selectedProduct?.id == option.id}
                              size="small"
                              sx={{
                                "&.Mui-checked": {
                                  color: "#000",
                                },
                              }}
                            />
                          </div>

                        </li>
                      )}


                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="m-0"
                          placeholder="Search Products"
                        />
                      )}
                    />
                    {selectedProduct &&
                      <div className="my-2 border rounded-3 p-3">
                        <div className="row">
                          <div className="col-md-6 col-12">
                            <div className="d-flex align-items-center gap-3">
                              <img style={{ width: "60px" }} src={selectedProduct?.image ? `${newImageUrl}${selectedProduct?.image}` : defaultImage} alt="" />
                              <div className="">
                                <h6 className='fw-bold label-size'>{selectedProduct?.name}</h6>
                                <h6 className='m-0 label-size main-text-color'>Type: {selectedProduct?.type}</h6>
                                <h6 className='m-0 label-size main-text-color'>Price:  <span className='fw-bold text-black'>{selectedProduct?.price * selectedProduct?.quantity} EGP</span></h6>

                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 col-12">
                            <div className="d-flex justify-content-between align-items-start">
                              <div className="">
                                <h6 className="m-0 main-text-color">Qty</h6>
                                <div className="border rounded-2 d-flex align-items-center">
                                  <button style={{ border: "none", outline: "none" }} onClick={decreaseQty} className='py-2 px-3 bg-transparent rounded-2 main-text-color'>-</button>
                                  <span>{selectedProduct?.quantity}</span>
                                  <button disabled={selectedProduct.quantity >= 2} style={{ border: "none", outline: "none", cursor:`${selectedProduct?.quantity >= 2 ? "not-allowed": "pointer"}` }} onClick={increaseQty} className='py-2 px-3 bg-transparent rounded-2 main-text-color'>+</button>
                                </div>
                              </div>
                              <div onClick={removeProduct} className="cursor">
                                <DeleteOutlinedIcon color='error' />
                              </div>
                            </div>
                          </div> 
                        </div>
                      </div>
                    }


                  </div>

                </>
              }
              {optionType == "multiple" &&
                <>
                  <div className="my-3">
                    <Autocomplete
                      multiple
                      className='w-100 h-100'
                      size="small"
                      disableCloseOnSelect
                      options={products}
                      value={selectedMultipleProducts}
                      id='products'
                      onChange={(e, value) => {
                        handleMultipleProductChange(value);
                      }}
                      getOptionLabel={(option) => option.name || ""}
//                       renderOption={(props, option) => (
//   <li
//     {...props}
//     className="px-1"
//     style={{
//       ...props.style,
//       opacity: option?.stock_status === "out_of_stock" ? 0.5 : 1,
//       pointerEvents:
//         option?.stock_status === "out_of_stock" ? "none" : "auto",
//     }}
//   >
//     <div className="d-flex justify-content-between align-items-center p-2 w-100">
// <div className="d-flex align-items-center gap-2">
//   <h6 className="fw-bold label-size m-0">
//     {option?.name}
//   </h6>

//   {option?.stock_status === "out_of_stock" && (
//     <span
//       style={{
//         color: "#d32f2f",
//         fontSize: "11px",
//         fontWeight: 600,
//       }}
//     >
//       Out of stock
//     </span>
//   )}
// </div>

//       <Checkbox
//         disabled={option?.stock_status === "out_of_stock"}
//         checked={selectedMultipleProducts.some(
//           (product) => product.id === option.id
//         )}
//         icon={<div style={boxStyle} />}
//         checkedIcon={
//           <div
//             style={{
//               ...boxStyle,
//               backgroundColor: "#000",
//             }}
//           >
//             <CheckIcon
//               style={{ color: "#fff", fontSize: 18 }}
//             />
//           </div>
//         }
//       />
//     </div>
//   </li>
// )}
                      renderOption={(props, option) => (
                        <li {...props}  
                   style={{
      ...props.style,
      opacity: option?.stock_status === "out_of_stock" ? 0.5 : 1,
      pointerEvents:
        option?.stock_status === "out_of_stock" ? "none" : "auto",
    }} className='px-1' >
                          <div className="d-flex justify-content-between align-items-center p-2">
                            <div className="d-flex align-align-items-start  gap-3">
                            <div className="">
                                <img
                                src={
                                  option.profile_image_url
                                    ? `${newImageUrl}${option.profile_image_url}`
                                    : defaultImage
                                }
                                style={{ width: 35, marginInline: 15, }}
                                alt=""
                              />
                            </div>
                              <div className="">
                                <h6 className='fw-bold label-size m-0'>{option?.name}</h6>
                                <h6 className='m-0 label-size main-text-color'>Type: {option?.product_details?.brand_name}</h6>
                                <h6 className='m-0 label-size main-text-color'>Price:  <span className='fw-bold text-black'>{option?.current_price} EGP</span></h6>
      
                              </div>
                                                       {option?.stock_status === "out_of_stock" && (
    <span
      style={{
        color: "#A80101",
        fontSize: "11px",
        fontWeight: 600,
      }}
    >
      Out of stock
    </span>
  )}
                              




                            </div> 
                            <Checkbox
                            disabled={option?.stock_status == "out_of_stock"}
                              checked={selectedMultipleProducts.some(
                                (product) => product.id == option.id
                              )}

                              icon={<div style={boxStyle} />}
                              checkedIcon={
                                <div
                                  style={{
                                    ...boxStyle,
                                    backgroundColor: "#000"
                                  }}
                                >
                                  <CheckIcon
                                    style={{ color: "#fff", fontSize: 18 }}
                                  />
                                </div>
                              }
                            />


                          </div>

                        </li>
                      )}


                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="m-0"
                          placeholder="Search Products"
                        />
                      )}
                    />
                    {selectedMultipleProducts.length > 0 &&
                      selectedMultipleProducts.map((product) => (

                        <div
                          key={product.id}
                          className="my-2 border rounded-3 p-3"
                        >

                          <div className="row">

                            <div className="col-md-6 col-12">

                              <div className="d-flex align-items-center gap-3">

                                <img
                                  style={{ width: "60px" }}
                                  src={
                                    product.image
                                      ? `${newImageUrl}${product.image}`
                                      : defaultImage
                                  }
                                  alt=""
                                />

                                <div>
                                  <h6 className='fw-bold label-size'>
                                    {product.name}
                                  </h6>

                                  <h6 className='m-0 label-size main-text-color'>
                                    Type: {product.type}
                                  </h6>

                                  <h6 className='m-0 label-size main-text-color'>
                                    Price:
                                    <span className='fw-bold text-black'>
                                      {product.price * product.quantity}  EGP
                                    </span>
                                  </h6>
                                </div>

                              </div>

                            </div>

                            <div className="col-md-6 col-12">

                              <div className="d-flex justify-content-between align-items-start">

                                <div>

                                  <h6 className="m-0 main-text-color">
                                    Qty
                                  </h6>

                                  <div className="border rounded-2 d-flex align-items-center">

                                    <button
                                      style={{
                                        border: "none",
                                        outline: "none"
                                      }}
                                      onClick={() =>
                                        decreaseMultipleQty(product.id)
                                      }
                                      className='py-2 px-3 bg-transparent rounded-2 main-text-color'
                                    >
                                      -
                                    </button>

                                    <span>{product.quantity}</span>

                                    <button
                                      style={{
                                        border: "none",
                                        outline: "none",
                                    
                                        cursor:`${product.quantity >= 2 ? "not-allowed": "pointer"}`
                                      }}
                                      disabled={product.quantity >= 2}
                                      onClick={() =>
                                        increaseMultipleQty(product.id)
                                      }
                                      className='py-2 px-3 bg-transparent rounded-2 main-text-color'
                                    >
                                      +
                                    </button>

                                  </div>

                                </div>

                                <div
                                  className="cursor"
                                  onClick={() =>
                                    removeMultipleProduct(product.id)
                                  }
                                >
                                  <DeleteOutlinedIcon color='error' />
                                </div>

                              </div>

                            </div>

                          </div>

                        </div>

                      ))}
                  </div>
                </>
              }


            </div>
            <div className="my-5">
              <div className="d-flex gap-2 align-items-start">
                <span
                  style={{
                    width: "25px", height: "25px",
                    padding: "10px", borderRadius: "50%",
                    backgroundColor: "#3FBEAC"
                  }}
                  className="d-flex justify-content-center align-items-center fw-bold"> 3
                </span>
                <div className="">
                  <h5 className="fw-semibold">Send to client</h5>
                  <p className="m-0 main-text-center label-size">The client will receive these options on their app.</p>


                </div>

              </div>
            </div>
            <div className="my-5 d-flex justify-content-between gap-2 align-items-center">
              <button
                onClick={
                  optionType === "single"
                    ? submitProduct
                    : submitMultipleProducts
                }
                className='px-5 btn btn-dark w-50'
              >
                {optionType == 'single' ? "Send option to client" : `Send ${selectedMultipleProducts.length} options to client`}
              </button>
              <button onClick={handleRecommendationClose} className="btn btn-light w-50 px-5">Cancel</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      
      <div className="m-4 min-vh-100">
        <div className="">
          <h6 className='m-0 main-text-color'>Request <span className="text-black mx-1 fw-bold">#{request.reference? request.reference : requestId}</span></h6>
          <div className="my-2">
            <Box
              sx={{
                width: "25%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <BottomNavigation
                showLabels
                value={tabValue}
                onChange={(event, newValue) => setTabValue(newValue)}
                sx={{
                  backgroundColor: {
                    xs: "transparent",
                    sm: "#f8f9fa"
                  },
                  height: "auto",
                  padding: 1,
                  borderRadius: {
                    sm: "10px",
                    xs: 0

                  },
                  width: "100%",
                  flexDirection: {
                    xs: "column",
                    sm: "row",
                  },

                  alignItems: {
                    xs: "center",
                  }
                  ,
                  ".MuiBottomNavigationAction-root": {
                    fontSize: "15px",
                    minWidth: 0,
                    padding: "8px 12px",
                    justifyContent: "center",
                    width: "100%",
                  },
                  ".Mui-selected": {
                    fontWeight: "bold",
                    fontSize: "12px"
                  },
                }}
              >
                <BottomNavigationAction label="Request details" />
                <BottomNavigationAction label="Activity logs" />


              </BottomNavigation>
            </Box>
          </div>

          <div style={{ height: "100vh", maxHeight: "100vh" }} className="row my-2  ">
            <div style={{ height: "100%" }} className="col-md-8 col-12 h-100">
              {tabValue == 0 ?
                <>
                  <div style={{ height: "100%" }} className="border rounded-2 ">
                    <div className="p-3 ">
                      <h6 className="m-0 fw-semibold">Request details</h6>

                    </div>

                    <div className="p-3 border-top my-2">
                      <Accordion
                        key={request.category?.id}
                        expanded={expandedOrder === request.category?.id}
                        onChange={() =>
                          setExpandedOrder(expandedOrder === request.category?.id ? null : request.category?.id)
                        }
                        sx={{
                          my: 2,

                          border: "none",
                          outline: "none",
                          "&:before": {
                            display: "none",
                          },
                          "&.Mui-expanded": {
                            boxShadow: "none",
                          },
                        }}
                        className="shadow-sm"
                      >
                        {/* ===== HEADER ===== */}
                        <AccordionSummary sx={{ backgroundColor: request.category?.parent?.background_color, borderRadius: 1, py: 1 }} expandIcon={<ExpandMoreIcon />}>
                          <div className="row w-100 align-items-center">
                            <div className="col-6 d-flex align-items-center">
                              <img
                                className=" mx-2"
                                src={
                                  request?.category?.parent?.icon_url
                                    ? `${newImageUrl}${request?.category?.parent?.icon_url}`
                                    : defaultImage
                                }
                                alt=""
                              />


                            </div>
                            <div className="col-6 d-flex gap-2 align-items-center justify-content-end">
                              <HelpIcon fontSize='large' />
                              <h6 className="m-0 label-size">{request.sub_type ? "Product Help Request" : "Support Help Request"}</h6>
                            </div>

                          </div>
                        </AccordionSummary>

                        {/* ===== DETAILS ===== */}
                        <AccordionDetails>
                          <h6 className="label-size main-text-color mt-3">Selected Items:</h6>
                          {request.category?.selections.length > 0 ?
                            <>

                              <div className="row">
                                {request.category?.selections.map((selection) =>
                                  selection.items.map((item) =>
                                    <>
                                      <div className="col-md-5 col-12">
                                        <div className="d-flex gap-2 align-items-center my-1">
                                          <h6 className="label-size main-text-color m-0">
                                            {item.item_type == "brand" ? "brand:" : item.item_type == "property" ? "property:" : item.item_type == "product" ? "product:" : null}
                                          </h6>
                                          <h6 className="m-0 label-size">{item.item_type == "brand" ? item.item?.name : item.item_type == "property" ? item.item?.value : item.item_type == "product" ? `${item.item.name} - ${item.item.sku}` : null}</h6>
                                        </div>
                                      </div>

                                    </>
                                  )


                                )}

                              </div>

                            </> : <>
                              <div className="m-0 label-size">No items Selected</div>

                            </>}
                          {request.sub_type == "filter" ?
                            <div className="my-4">
                              <div className="my-2 d-flex gap-3 align-items-center">
                                <h6 className="label-size main-text-color m-0">
                                  Change filter:
                                </h6>
                                <div className="d-flex gap-2 align-items-center">
                                  <HelpIcon fontSize='small' />
                                  <h6 className="m-0 label-size">Help Request</h6>
                                      <div
                                              style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: "6px",
                                                backgroundColor: isUpdated ? "#e6f4f1" : "#f5f5f5",
                                                border: `1px solid ${isUpdated ? "#3EADA3" : "#e0e0e0"}`,
                                                borderRadius: "20px",
                                                padding: "4px 10px",
                                                transition: "all 0.3s ease",
                                                boxShadow: isUpdated ? "0 0 0 3px rgba(62,173,163,0.2)" : "none",
                                                animation: isUpdated ? "statusPulse 0.6s ease" : "none",
                                              }}
                                            >
                                              <img
                                                src={request?.status_icon || defaultImage}
                                                alt=""
                                                style={{ width: "14px", height: "14px", objectFit: "contain" }}
                                              />
                                              <span
                                                style={{
                                                  fontWeight: 600,
                                                  fontSize: "11px",
                                                  color: isUpdated ? "#3EADA3" : "#444",
                                                  whiteSpace: "nowrap",
                                                  transition: "color 0.3s ease",
                                                }}
                                              >
                                                {request?.status || "-"}
                                              </span>
                                            </div>
                             
                                </div>
                              </div>
                             
                            </div>
                            :
                            <div className="my-4">
                              <div className="my-2 d-flex gap-3 align-items-center">
                                <h6 className="label-size main-text-color m-0">
                                  {request?.category?.name}:
                                </h6>
                                <div className="d-flex gap-2 align-items-center">
                                  <HelpIcon fontSize='small' />
                                  <h6 className="m-0 label-size">Help Request</h6>
                                     <div
                                              style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: "6px",
                                                backgroundColor: isUpdated ? "#e6f4f1" : "#f5f5f5",
                                                border: `1px solid ${isUpdated ? "#3EADA3" : "#e0e0e0"}`,
                                                borderRadius: "20px",
                                                padding: "4px 10px",
                                                transition: "all 0.3s ease",
                                                boxShadow: isUpdated ? "0 0 0 3px rgba(62,173,163,0.2)" : "none",
                                                animation: isUpdated ? "statusPulse 0.6s ease" : "none",
                                              }}
                                            >
                                              <img
                                                src={request?.status_icon || defaultImage}
                                                alt=""
                                                style={{ width: "14px", height: "14px", objectFit: "contain" }}
                                              />
                                              <span
                                                style={{
                                                  fontWeight: 600,
                                                  fontSize: "11px",
                                                  color: isUpdated ? "#3EADA3" : "#444",
                                                  whiteSpace: "nowrap",
                                                  transition: "color 0.3s ease",
                                                }}
                                              >
                                                {request?.status || "-"}
                                              </span>
                                            </div>
                                </div>
                              </div>

                            </div>


                          }
                          {request.sub_type == "filter" &&
                            <div  style={{ border: "2px dashed #C6C6C6" }} className="p-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex gap-2 align-items-center">
                                  {isResolved ? selectedProductsImage :   <div className="">
                                    <img src={ recommendation} alt="" className="" /> 
                                  </div>}
                                 
                                  <div className="">
                                    {isPending &&
                                   <>
                                   <h6 className="m-0">No Product recommendations added yet </h6>
                                  <h6 className="m-0 main-text-color label-size">Add product options to help the client choose the right oil filter.</h6>
                                   </>
                                   }
                                    {isSentToUser &&
                                   <>
                                    <h6 className="m-0">Product recommendations sent to the client </h6>
                                    <h6 className="m-0 main-text-color label-size">Waiting for client response.</h6>
                                     </>}
                                    {isResolved && 
                                    <>
                                    <h6 className="m-0">Client approved the product recommendations</h6>
                                    <h6 className="m-0 main-text-color label-size">The selected products is ready for execution.</h6> 
                                    </>
                                    }
                                    {isUnResolved && 
                                    <>
                                    <h6 className="m-0">Client rejected the product recommendations</h6>
                                    <h6 className="m-0 main-text-color label-size">The request has been closed as the client did not accept any of the suggested products.</h6> 
                                    </>
                                    }
                                    {isCancelled && 
                                    <>
                                    <h6 className="m-0">Client cancelled the help request</h6>
                                    <h6 className="m-0 main-text-color label-size">The request was cancelled by the client before any product recommendations were sent.</h6>
                                    </>
                                    }
                                  </div>
                                </div>

                                <div className="">
                                 {isPending &&  <button onClick={() => handleRecommendationShow(request.category)} className="btn btn-dark px-3">
                                    <Add sx={{ mx: "2px" }} />
                                    Add Recommendations</button>}
                                     {!isCancelled && !isPending &&
                                     <button onClick={handleFilterDataShow}  className="btn btn-dark px-3">
                                    <RemoveRedEyeOutlinedIcon sx={{ mx: "2px" }} />
                                    View Recommendations </button> 
                                    
                                    }
                                </div>
                              </div>
                            </div>}


                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                </> :
                <>
                  <div style={{ height: "100%" }} className="border rounded-2 ">
                    <div className="p-3 d-flex justify-content-between align-items-center">
                      <h6 className="m-0 fw-semibold">Activity Logs</h6>
                      <button onClick={handleActivityShow} className="btn btn-light">
                        <Add sx={{ mx: "2px" }} />
                        Add Activity
                      </button>
                    </div>

                    <div className="p-3 border-top my-2">
                      {activities?.length > 0 ?
                        activities?.map((activity) => (
                          <ActivityItem
                            request={request}
                            key={activity.id}
                            activity={activity}
                            requestId={requestId}
                            token={token}
                            newHost={newHost}
                            callTypes={callTypes}
                            callStatuses={callStatuses}
                            activityTypes={activityTypes}
                            getRequest={getRequest}
                            handleDeleteShow={handleDeleteShow}
                            handleDeleteClose={handleDeleteClose}
                            setActivityId={setActivityId}
                            activityId={activityId}
                          />
                        ))
                        :
                        <div className="flex flex-column text-center">

                          <img src={noData} alt="no-data" />
                          <p style={{ color: "#535353" }} className=''>No available activity logs</p>
                        </div>


                      }

                    </div>
                  </div>


                </>}

            </div>
            <div style={{ height: "100%" }} className="col-md-4 col-12">
              <div className="border rounded-2 p-3">
                <h6 className='m-0 main-text-color'>Request <span className="text-black mx-1 fw-bold">#{request.reference? request.reference : requestId}</span></h6>
                <div className="d-flex justify-content-between align-items-center my-3">
                  <h6 className="m-0 main-text-color label-size">Category:</h6>
                  <img style={{width:"30px",height:"30px"}} src={
                                  request?.category?.parent?.icon_url
                                    ? `${newImageUrl}${request?.category?.parent?.icon_url}`
                                    : defaultImage
                                } alt="" />
                </div>
                <div className="d-flex justify-content-between align-items-center my-3">
                  <h6 className="m-0 main-text-color label-size">Date:</h6>
                  <h6 className="m-0 main-text-color label-size">{`${new Date(request.created_at).toLocaleDateString()} - ${new Date(request.created_at).toLocaleTimeString()}`}</h6>
                </div>
                <div className="d-flex justify-content-between align-items-center my-3">
                  <h6 className="m-0 main-text-color label-size">Car Model:</h6>
                  <h6 className="m-0 main-text-color label-size">{request.user_vehicle}</h6>
                </div>
              </div>
              <div style={{ height: "75%" }} className="border rounded-2 p-3 my-3">
                <h6 className='m-0'>Client</h6>
                <div className=" d-flex justify-content-between align-items-center my-3">
                  <div className=" d-flex justify-content-between ">
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        minHeight: "50px",
                        minWidth: "50px",
                        borderRadius: "50%",
                      }}
                      className="mt-1 overflow-hidden"
                    >
                      <img
                        style={{
                          width: "50px",
                          height: "50px",
                          minHeight: "50px",
                          minWidth: "50px",
                          borderRadius: "50%",
                        }}
                        className="object-fit-fill"
                        src={
                          request?.user?.profile_photo_path
                            ? `${newImageUrl}${request.user.profile_photo_path}`
                            : defaultImage
                        }

                        alt=""
                      />
                    </div>
                    <div className=" mx-2">
                      <p className="my-0 fs-6 fw-medium">{request.user?.name}</p>
                      <p className=" client-birthdate text-muted fs-6">
                        <i className="fa-solid fa-cake-candles me-1"></i>
                        {request.user?.birthdate}
                      </p>
                    </div>
                  </div>
                  <div>
                    <i className="fa-solid fa-chevron-right"></i>
                  </div>
                </div>
                <p className=" fs-5 fw-semibold my-3">Client Info</p>
                <div className=" client-info-data my-3">
                  <p className='main-text-color my-3 mx-0'>
                    <i className="fa-solid fa-phone me-2 text-muted"></i>
                    {request.user?.phone_number}
                  </p>
                  <p className='main-text-color my-3 mx-0'>
                    <i className="fa-regular fa-envelope me-2 text-muted"></i>
                    {request.user?.email}
                  </p>

                  <p className='main-text-color my-3 mx-0'>
                    <i className="fa-solid fa-circle me-2 text-success"></i>
                    {`Last activity : ${new Date(request.user?.user_last_activity?.last_seen_at).toLocaleDateString()} - ${new Date(request.user?.user_last_activity?.last_seen_at).toLocaleTimeString()}`}
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </>
  )
}

export default HelpRequestProfile